<template>
  <div class="card-container">
   <div style="display:flex">
      <common-top-form
      selectShowPower="/cashmanage/select"
      :model="formModel"
      @openAddDialog="changeInfo()"
      :submitService="submitService"
      
      addShowPower="/cashmanage/add"
      :submitData="submitData"
      @success="onSuccess"
      :show="true"
    >
    <!--  -->

      <el-form-item label="机构名称" prop="activityName">
         <el-select style="width: 198px" v-model="formModel.tatSimpleId" filterable>
                    <el-option
                        v-for="item in typeTwo"
                        :key="item"
                        :label="item.tatName"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
      </el-form-item>
    </common-top-form>
    <!-- 这里新添加的批量 -->
     <div  v-if='this.textTatSimpleId' style="margin-right: 20px">
      <div>
        <div class="span" style="display: flex; align-items: center">
        
          <div>
            <el-button style="width: 100px" type="warning" @click="openAll()"
              >批量启用
            </el-button>
          </div>
        </div>
      </div>
    </div>
     <div  v-if='this.textTatSimpleId'>
      <div>
        <div class="span" style="display: flex; align-items: center">
        
          <div>
            <el-button style="width: 100px" type="warning" @click="closeAll()"
              >批量禁用
            </el-button>
          </div>
        </div>
      </div>
    </div>
   </div>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
          <el-table-column
        prop="tatSimpleName"
        label="机构名称"
        min-width="100"
        show-overflow-tooltip
       
      ></el-table-column>
      <el-table-column
        prop="acctType"
        label="账户类型"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableacctType"
      ></el-table-column>
      <el-table-column
        prop="withdrawFee"
        label="机构费率%+元"
        min-width="150"
        show-overflow-tooltip
        :formatter="formatterTableNumberYuan"
      >
      <template slot-scope="scope">
          <p>{{scope.row.withdrawFee.toFixed(2)+ '%'}} + {{ toDoubleThousands((scope.row.withdrawRate * 100) / 10000) }}</p>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="withdrawRate"
        label="元/笔-机构"
        min-width="150"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p>{{ toDoubleThousands((scope.row.withdrawRate * 100) / 10000) }}</p>
        </template>
      </el-table-column> -->
      <!-- 新增 -->
      <el-table-column
        prop="withdrawFeeMem"
        label="用户费率%+元"
        min-width="150"
        show-overflow-tooltip
        :formatter="formatterTableNumberYuan"
        
      >
       <template slot-scope="scope">
                  <p>{{scope.row.withdrawFeeMem.toFixed(2)+ '%'}} + {{ toDoubleThousands((scope.row.withdrawRateMem * 100) / 10000) }}</p>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="withdrawRateMem"
        label="元/笔-用户"
        min-width="150"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p>{{ toDoubleThousands((scope.row.withdrawRateMem * 100) / 10000) }}</p>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="withdrawMin"
        label="提现最小值(元)"
        min-width="120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p>{{ toDoubleThousands((scope.row.withdrawMin * 100) / 10000) }}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="withdrawMax"
        label="提现最大值(元)"
        min-width="120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p>{{ toDoubleThousands((scope.row.withdrawMax * 100) / 10000) }}</p>
        </template>
      </el-table-column>
      <!-- 新增机构名称 -->
    
      <el-table-column
        prop="remark"
        label="备注"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p>{{ scope.row.status == 1 ? "启用" : "禁用" }}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="修改时间"
        min-width="160"
      ></el-table-column>
      <el-table-column
        label="操作"
        min-width="160"
        v-if="
          hasPerm('/cashmanage/edit') ||
          hasPerm('/cashmanage/delete') ||
          hasPerm('/cashmanage/udpStatus')
        "
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="changeInfo(scope.row.id)"
            v-if="hasPerm('/cashmanage/edit')"
            >修改</el-button
          >
          <!-- <el-button
            type="text"
            @click="DeleteInfo(scope.row.id)"
            class="button-color"
            v-if="hasPerm('/cashmanage/delete')"
            >删除</el-button
          > -->
          <el-button
            type="text"
            @click="Disabled(scope.row.id, scope.row.status)"
            class="button-color"
            v-if="hasPerm('/cashmanage/udpStatus')"
          >
            {{ scope.row.status == 1 ? "禁用" : "启用" }}
          </el-button>
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="formDialogTitle"
      :model="dialogModel"
      :dialogService="dialogService"
      :submitData="dialogData"
      :rules="dialogRules"
      @success="dialogSuccess"
      @close="dialogClose"
      @opend="dialogOpen"
      class="note"
      dialogWidth="840px"
      labelWidth="130px"
    >
       <el-form-item label="机构名称" prop="activityName">
         <el-select style="width: 198px" v-model="dialogModel.tatSimpleId" filterable>
                    <el-option
                        v-for="item in typeTwo"
                        :key="item"
                        :label="item.tatName"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
      </el-form-item>
      <!-- 新增 -->
           <el-form-item label="账户类型" prop="acctType">
                <el-select v-model="dialogModel.acctType"  style="width: 198px">
                    <el-option
                        placeholder="请选择"
                        v-for="item in acctType.slice(1, acctType.length)"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
      <el-form-item label="提现最小值" prop="withdrawMin">
        <el-input-number
          :controls="false"
          placeholder="请输入"
          v-model="dialogModel.withdrawMin"
          controls-position="right"
          :precision="2"
          :step="0.1"
          @change="handleChange"
          :min="0"
          style="width: 180px"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="提现最大值" prop="withdrawMax">
        <el-input-number
          :controls="false"
          placeholder="请输入"
          v-model="dialogModel.withdrawMax"
          controls-position="right"
          :precision="2"
          :step="0.1"
          @change="handleChange"
          :min="0"
          style="width: 180px"
        ></el-input-number>
      </el-form-item>
      <div class="flex-row vertical-center">
        <div
          class="flex-row vertical-center flow-justify"
          style="margin-right: 20px"
        >
          <el-form-item label="提现费率(机构)" prop="withdrawFee" style="width: 100%">
            <el-input-number
              :controls="false"
              v-model="dialogModel.withdrawFee"
              controls-position="right"
              :precision="2"
              :step="0.1"
              @change="handleChange"
              :min="0"
              style="width: 180px"
            ></el-input-number>
            <span>%</span>
          </el-form-item>
        </div>
        <div class="flex-row vertical-center flow-justify">
          <el-form-item prop="withdrawRate">
            <div class="flex-row vertical-center">
              <div class="flex-row vertical-center flow-justify">
                <el-input-number
                  :controls="false"
                  placeholder="请输入"
                  v-model="dialogModel.withdrawRate"
                  controls-position="right"
                  :precision="2"
                  :step="0.1"
                  @change="handleChange"
                  :min="0"
                  style="width: 180px"
                ></el-input-number>
                <p class="unit">元/笔(机构)</p>
              </div>
            </div>
          </el-form-item>
        </div>
      </div>
      <!-- 新增 -->
      <div class="flex-row vertical-center">
        <div
          class="flex-row vertical-center flow-justify"
          style="margin-right: 20px"
        >
          <el-form-item label="提现费率(用户)" prop="withdrawFeeMem">
            <el-input-number
              :controls="false"
              v-model="dialogModel.withdrawFeeMem"
              controls-position="right"
              :precision="2"
              :step="0.1"
              @change="handleChange"
              :min="0"
              style="width: 180px"
            ></el-input-number>
            <span>%</span>
          </el-form-item>
        </div>
        <div class="flex-row vertical-center flow-justify">
          <el-form-item prop="withdrawRateMem">
            <div class="flex-row vertical-center">
              <div class="flex-row vertical-center flow-justify">
                <el-input-number
                  :controls="false"
                  placeholder="请输入"
                  v-model="dialogModel.withdrawRateMem"
                  controls-position="right"
                  :precision="2"
                  :step="0.1"
                  @change="handleChange"
                  :min="0"
                  style="width: 180px"
                ></el-input-number>
                <p class="unit">元/笔(用户)</p>
              </div>
            </div>
          </el-form-item>
        </div>
      </div>
      <el-form-item label="描述" prop="remark">
        <el-input
          maxlength="80"
          show-word-limit
          v-model="dialogModel.remark"
          type="textarea"
          resize="none"
        ></el-input>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";

import OrganCashService from "service/OrganCashService";
import LYFAcctTypes from "service/constant/LYFAcctTypes";

import privateKey from "service/constant/privateKey";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";
import SelectOrgans from "components/business/SelectOrgans";
import activity from "service/Ainstitution";
export default {
  name: "cashmanage",
  data() {
    return {
        acctType: LYFAcctTypes,
      formModel: {},
      submitService: OrganCashService.list,
      page: {},
      params: {},
      tableData: [],
      formDialogTitle: "",
        typeTwo: [{ tatName: "全部", id: "" }],
      dialogModel: {
        tatSimpleId:'',
        acctType: '',
        withdrawFee: "0",
        withdrawMax: "0",
        withdrawMin: "0",
        withdrawRate: "0",
        remark: "",
        withdrawFeeMem: "0",
        withdrawRateMem: "0",
      },
      dialogRules: {
          activityName: [
                        {
                            required: false,
                            message: "请选择",
                        },
                    ],
        withdrawFee: [
          {
            required: true,
            message: "请输入计费标准",
          },
        ],
        withdrawFeeMem: [
          {
            required: true,
            message: "请输入计费标准",
          },
        ],
        withdrawMax: [
          {
            required: true,
            message: "请输入",
          },
        ],
        withdrawMin: [
          {
            required: true,
            message: "请输入",
          },
        ],
        withdrawRate: [
          {
            required: true,
            message: "请输入",
          },
        ],
        withdrawRateMem: [
          {
            required: true,
            message: "请输入",
          },
        ],
          acctType: [
                        {
                            required: true,
                            message: "请选择",
                        },
                    ],
      },
      cashId: "",
      checkFlag: false,
      isPage: false,
    };
  },
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
    SelectOrgans,
  },
  computed: {
    isExist() {
      return this.checkFlag;
    },
    submitData() {
      this.params = {
        userId: this.userId,
        tatSimpleId: this.formModel.tatSimpleId,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      return this.params;
    },

    dialogService() {
      if (this.cashId) {
        return OrganCashService.update;
      } else {
        return OrganCashService.add;
      }
    },
    dialogData() {
      const params = {
        userId: this.userId,
        tatSimpleId: this.dialogModel.tatSimpleId,
        acctType: this.dialogModel.acctType,
        withdrawFee: this.dialogModel.withdrawFee,
        withdrawMin: this.dialogModel.withdrawMin * 100,
        withdrawMax: this.dialogModel.withdrawMax * 100,
        withdrawRate: this.dialogModel.withdrawRate * 100,
        withdrawFeeMem: this.dialogModel.withdrawFeeMem,
        withdrawRateMem: this.dialogModel.withdrawRateMem * 100,
        remark: this.dialogModel.remark,
      };
      if (this.cashId) {
        params.id = this.cashId;
      }
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId","textTatSimpleId"]),
  },
  mounted() {
    this.page = this.$refs.commonTable.page;
    this.getTypeTwo()
    this.getList();
  },
  methods: {
          getTypeTwo() {
        this.doLoad(
        activity.signList,
        {
          size: 9999,
        },
        (res) => {
          this.doCheck(res, (res) => {
            console.log(res.contents.rows,'res1')
            res.contents.rows.forEach(item => {
              item.dictValue = item.id,
              item.dictKey = item.tatName
            })
            this.typeTwo = [...this.typeTwo,...res.contents.rows];
          });
        },
        "信息获取失败"
      );
    },
    // 批量结算
    openAll() {
          this.$confirm('是否启用?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
           this.doLoad(
        OrganCashService.addAllDel,
        {status: 1},
        (res) => {
          this.doCheck(res, (res) => {
             this.$message({
            type: 'success',
            message: '启用成功!'
          });
           this.getList();
           console.log(res)
          });
        },
        "信息获取失败"
      );
         
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });          
        });
    },
        closeAll() {
          this.$confirm('是否禁用用?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
           this.doLoad(
        OrganCashService.addAllDel,
        {status: 0},
        (res) => {
          this.doCheck(res, (res) => {
             this.$message({
            type: 'success',
            message: '禁用成功!'
          });
           this.getList();
           console.log(res)
          });
        },
        "信息获取失败"
      );
         
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });          
        });
    },
    changeInfo(id) {
      if (id) {
        this.formDialogTitle = "修改提现";
      } else {
        this.formDialogTitle = "添加提现";
      }
      this.cashId = id;
      this.$refs.formDialog.open();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        OrganCashService.list,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.tableData = result.rows;

            this.page.currentPage = result.current;
            this.page.pageSize = result.size;
            this.page.total = result.total;
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    getDetail() {
      const params = {
        id: this.cashId,
      };

      this.doLoad(
        OrganCashService.detail,
        params,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.dialogModel = result;
            // this.dialogModel.withdrawFee =
            //   (this.dialogModel.withdrawFee * 100) / 10000;
            this.dialogModel.withdrawMax =
              (this.dialogModel.withdrawMax * 100) / 10000;
            this.dialogModel.withdrawMin =
              (this.dialogModel.withdrawMin * 100) / 10000;
            this.dialogModel.withdrawRate =
              (this.dialogModel.withdrawRate * 100) / 10000;
            this.dialogModel.withdrawRateMem =
              (this.dialogModel.withdrawRateMem * 100) / 10000;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;

        this.page.currentPage = result.current;
        this.page.pageSize = result.size;
        this.page.total = result.total;
      });
    },
    dialogSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.showSuccess(result.optMsg);
        this.$refs.formDialog.closeDialog();
        this.getList();
      });
    },
    dialogClose() {
      this.dialogModel = {
        withdrawFee: "0",
        withdrawMin: "0",
        withdrawMax: "0",
        withdrawRate: "0",
        withdrawFeeMem: "0",
         withdrawRateMem: "0",
         acctType: '',
         tatSimpleId: '',
        remark: "",
      };
    },
    dialogOpen() {
      if (this.cashId) {
        this.getDetail();
      }
    },
    doDisabled(id) {
      const disabledParams = {
        id: id,
        status: this.status,
        userId: this.userId,
      };
      this.doLoad(
        OrganCashService.dpStatus,
        disabledParams,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.showSuccess(result.optMsg);
            this.getList();
          });
        },
        "操作失败"
      );
    },
    Disabled(id, type) {
      if (type == 0) {
        this.status = 1;
        this.showMsg = "确定启用此机构？";
      } else if (type == 1) {
        this.status = 0;
        this.showMsg = "确定禁用此机构？";
      }
      this.showConfirm(this.showMsg)
        .then(() => {
          this.doDisabled(id);
        })
        .catch(() => {});
    },
    handleChange() {},
    doDeleteInfo(id) {
      const disabledParams = {
        id: id,
      };
      this.doLoad(
        OrganCashService.delInfo,
        disabledParams,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.showSuccess(result.optMsg);
            this.getList();
          });
        },
        "操作失败"
      );
    },
    DeleteInfo(id) {
      this.showMsg = "确定删除此实名通道？";
      this.showConfirm(this.showMsg)
        .then(() => {
          this.doDeleteInfo(id);
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.unit {
  width: 100px;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/CashManage.vue